import api from '@app/api'

import { CONTENT_TYPES } from '@app/api/constants'

import type { AblePaginatedResponseFn, ResponseDto } from '@app/api/dtos'
import type { ContractorsClusterDto, ContractorsDto } from './dtos'
import type {
  PatchContractorsData,
  PostContractorsClusterData,
  CommonContractorsData,
  ExportExcel,
  DeleteContractorsClusterData
} from './types'
import type { DefaultParams } from '@app/api/types'

const URL = '/contractors/'

const DEFAULT_PARAMS = {
  limit: 1500
}

export const getContractors: AblePaginatedResponseFn<DefaultParams, ContractorsDto> = async params => {
  const response = await api.get(URL, { params })
  return response.data
}

export const getContractorsCluster = async (
  params: DefaultParams = DEFAULT_PARAMS
): Promise<ResponseDto<ContractorsClusterDto>> => {
  const response = await api.get<ResponseDto<ContractorsClusterDto>>(`${URL}clusters/`, { params })
  return response.data
}

export const createContractor = async (data: CommonContractorsData): Promise<void> => {
  const response = await api.post(URL, data)
  return response.data
}

export const patchContractor = async ({ id, data }: PatchContractorsData): Promise<void> => {
  const response = await api.patch(`${URL}${id}/`, data)
  return response.data
}

export const postContractorsCluster = async (data: PostContractorsClusterData): Promise<void> => {
  await api.post(`${URL}clusters/`, data)
}

export const deleteContractorsCluster = async (data: DeleteContractorsClusterData): Promise<void> => {
  await api.delete(`${URL}clusters/`, { data })
}

export const exportContractorsCluster = async (params: ExportExcel, signal?: AbortSignal): Promise<Blob> => {
  const response = await api.get<Blob>(`${URL}clusters/export/`, {
    signal,
    params,
    responseType: 'blob',
    headers: {
      'Content-Type': CONTENT_TYPES.applicationOfficedocumentSpreadsheetml
    }
  })

  return response.data
}
